import React from 'react';
import '../Sidebar/sidebar.css';
import { AiFillCaretDown, AiOutlineRight, AiOutlineMenu, AiOutlineInfoCircle, AiFillApple } from "react-icons/ai";
import { useHistory, NavLink } from "react-router-dom";
import Accordion from 'react-bootstrap/Accordion';
import '../../Style/typo.css'

function Sidebar() {
  const currentRoute = useHistory().location?.hash;
  return (
    <Accordion defaultActiveKey={["#cluster", "#microservice", "#storage"]} alwaysOpen className='sidebardesk'>
      {/* <Accordion defaultActiveKey={currentRoute} className='sidebardesk'> */}
      {/* <Accordion.Item eventKey="#server" className="menu-accordion-item">
        <Accordion.Header>
          <h5>Server</h5>
        </Accordion.Header>
        <Accordion.Body>
          <ul className='sidebar-main'>
            <NavLink to="/compute-vps#server">가상서버 (인스턴스)</span></NavLink>
            <NavLink to="/compute-bare-metal#server">베어메탈 서버 (단독서버)</span></NavLink>
            <NavLink to="/compute-auto-scale#server">오토스케일링</span></NavLink>
            <NavLink to="/compute-load-balance#server">로드발랜서</span></NavLink>
            <NavLink to="/compute-database#server">데이터베이스 (인스턴스)</span></NavLink>
            <NavLink to="/compute-ms#server">MS-SQL / Windows</span></NavLink>

          </ul>
        </Accordion.Body>
      </Accordion.Item> */}

      {/* <Accordion.Item eventKey="#cluster">
        <Accordion.Header>
          <h5>Kubernetes Clusters</h5>
        </Accordion.Header>
        <Accordion.Body>
          <div className='left-menu-box'>
            <h6>Application</h6>
            <ul className='sidebar-main'>
              <NavLink to="/cluster-cloud-elastic-search#cluster">Elastic Search</span></NavLink>
              <NavLink to="/cluster-kafka#cluster">Kafka</span></NavLink>
            </ul>
          </div>

          <div className='left-menu-box'>
            <h6>Database</h6>
            <ul className='sidebar-main'>
              <NavLink to="/cluster-cloud-mysql-db#cluster">MySQL</span></NavLink>
              <NavLink to="/cluster-cloud-postgresql-db#cluster">PostgreSQL</span></NavLink>
              <NavLink to="/cluster-cloud-vitess#cluster">Vitess</span></NavLink>
              <NavLink to="/cluster-cloud-mongodb#cluster">MongoDB</span></NavLink>
              <NavLink to="/cluster-cloud-redis#cluster">Redis</span></NavLink>
              <NavLink to="/cluster-cloud-scylladb#cluster">ScyllaDB</span></NavLink>
              <NavLink to="/cluster-clickhouse#cluster">ClickHouse</span></NavLink>
            </ul>
          </div>
        </Accordion.Body>
      </Accordion.Item> */}

      <Accordion.Item eventKey="#cluster" className="menu-accordion-item">
        <Accordion.Header>
          <p class="typo-14 typo-medium purple-primary">Private Kubernetes</p>
        </Accordion.Header>
        <Accordion.Body>
          <ul className='sidebar-main'>
            <NavLink to="/private-cloud#cluster"><AiOutlineRight className="icon-right" /><span class="typo-14">장점</span></NavLink>

            <NavLink to="/soho#cluster"><AiOutlineRight className="icon-right" /><span class="typo-14">시스템 구성</span></NavLink>
            <ul className='sidebar-sub' id="sub-menu2#cluster">
              <NavLink to="/soho/soho1#cluster"><AiOutlineRight className="icon-right" /><span class="typo-14">소호형</span></NavLink>
              <NavLink to="/soho/scalable#cluster"><AiOutlineRight className="icon-right" /><span class="typo-14">확장형</span></NavLink>
              <NavLink to="/soho/enterprise#cluster"><AiOutlineRight className="icon-right" /><span class="typo-14">엔터프라이즈형</span></NavLink>
            </ul>

            <NavLink to="/monitor#cluster"><AiOutlineRight className="icon-right" /><span class="typo-14">기능 및 관리 도구</span></NavLink>
            <ul className='sidebar-sub' id="sub-menu1#cluster">
              <NavLink to="/monitor/monitoring-volume#cluster"><AiOutlineRight className="icon-right" /><span class="typo-14">모니터링•볼륨 구조</span></NavLink>
              {/* <NavLink to="/back-office#cluster">한비로 백오피스</NavLink> */}
            </ul>

            <NavLink to="/application#cluster"><AiOutlineRight className="icon-right" /><span class="typo-14">Application</span></NavLink>
            <ul className='sidebar-sub' id="sub-menu3#cluster">
              <NavLink to="/application/cluster-cloud-elastic-search#cluster"><AiOutlineRight className="icon-right" /><span class="typo-14">Private ElasticSearch Cluster</span></NavLink>
              <NavLink to="/application/cluster-kafka#cluster"><AiOutlineRight className="icon-right" /><span class="typo-14">Private Kafka Cluster</span></NavLink>
              <NavLink to="/application/cluster-cloud-mysql-db#cluster"><AiOutlineRight className="icon-right" /><span class="typo-14">Private MySQL Cluster</span></NavLink>
              <NavLink to="/application/cluster-cloud-postgresql-db#cluster"><AiOutlineRight className="icon-right" /><span class="typo-14">Private PostgreSQL Cluster</span></NavLink>
              <NavLink to="/application/cluster-cloud-vitess#cluster"><AiOutlineRight className="icon-right" /><span class="typo-14">Private Vitess Cluster</span></NavLink>
              <NavLink to="/application/cluster-cloud-mongodb#cluster"><AiOutlineRight className="icon-right" /><span class="typo-14">Private MongoDB Cluster</span></NavLink>
              <NavLink to="/application/cluster-cloud-redis#cluster"><AiOutlineRight className="icon-right" /><span class="typo-14">Private Redis Cluster</span></NavLink>
              <NavLink to="/application/cluster-cloud-scylladb#cluster"><AiOutlineRight className="icon-right" /><span class="typo-14">Private ScyllaDB Cluster</span></NavLink>
              <NavLink to="/application/cluster-clickhouse#cluster"><AiOutlineRight className="icon-right" /><span class="typo-14">Private ClickHouse Cluster</span></NavLink>
            </ul>

          </ul>
        </Accordion.Body>
      </Accordion.Item>

      <Accordion.Item eventKey="#microservice" className="menu-accordion-item">
        <Accordion.Header>
          <p class="typo-14 typo-medium purple-primary">Serverless Application</p>
        </Accordion.Header>
        <Accordion.Body>
          <ul className='sidebar-main'>
            {/* <NavLink to="/msa1#microservice">마이크로서비스 기반개발이란</NavLink> */}
            <NavLink to="/msa2#microservice"><AiOutlineRight className="icon-right" /><span class="typo-14">마이크로서비스 개발의 필수요소들</span></NavLink>
            <NavLink to="/msa3#microservice"><AiOutlineRight className="icon-right" /><span class="typo-14">어플리케이션 통합과 서비스</span></NavLink>
            <ul className='sidebar-sub' id="sub-menu#microservice">
              <NavLink to="/msa3/iaam#microservice"><AiOutlineRight className="icon-right" /><span class="typo-14">Identity And Access Management</span></NavLink>
              <NavLink to="/msa3/messaging-service#microservice"><AiOutlineRight className="icon-right" /><span class="typo-14">Messaging Service</span></NavLink>
              <NavLink to="/msa3/event-sourcing#microservice"><AiOutlineRight className="icon-right" /><span class="typo-14">Event Sourcing</span></NavLink>
              <NavLink to="/msa3/webhook#microservice"><AiOutlineRight className="icon-right" /><span class="typo-14">Webhook</span></NavLink>
              <NavLink to="/msa3/long-running#microservice"><AiOutlineRight className="icon-right" /><span class="typo-14">Long-Running</span></NavLink>
              <NavLink to="/msa3/simple-url-shortener#microservice"><AiOutlineRight className="icon-right" /><span class="typo-14">Simple-Url-Shortener</span></NavLink>
              <NavLink to="/msa3/simple-storage-service#microservice"><AiOutlineRight className="icon-right" /><span class="typo-14">S3 (Simple Storage Serice)</span></NavLink>
            </ul>
          </ul>
        </Accordion.Body>
      </Accordion.Item>

      {/* <Accordion.Item eventKey="#storage" className="menu-accordion-item">
        <Accordion.Header>
          <h5>Storage</h5>
        </Accordion.Header>
        <Accordion.Body>
            <ul className='sidebar-main'>
                <NavLink to="/store-object-store#storage">오브젝트 Storage</span></NavLink>
                <NavLink to="/store-block-store#storage">불록 Storage</span></NavLink>
                <NavLink to="/store-nas-store#storage">공유 Storage</span></NavLink>
            </ul>
        </Accordion.Body>
      </Accordion.Item> */}
    </Accordion>
  );
}


export default Sidebar;